import React, { FC } from 'react'
// @src imports
import { Icon, SuspenseBoundary } from 'src/chrome'

import { FlexColumn } from 'src/styled'

import { useQueries } from 'src/hooks'

// relative imports
import BaseCreditCard from '../BaseCreditCard/BaseCreditCard'

import styles from './styles'
import { Text } from '@sendoutcards/quantum-design-ui'
import { Currency, getCreditsBalance } from 'src/graphql'
import { CircularProgress } from '@material-ui/core'

const CreditsUnavailable: FC = () => (
  <Text type="caption" color="danger">
    Your credits balance is unavailable at the moment, try again later.
  </Text>
)

const ReferralCredits: FC = () => {
  const [credits] = useQueries(getCreditsBalance())

  const isUnavailable = credits.currency === Currency.UNAVAILABLE

  return (
    <>
      {isUnavailable ? (
        <CreditsUnavailable />
      ) : (
        <>
          <span css={styles.amount}>{credits.description}</span>
          <Text type="caption" weight="bold">
            Credits
          </Text>
        </>
      )}
    </>
  )
}

const ReferralCreditsCard: FC = () => {
  return (
    <BaseCreditCard css={{ backgroundColor: '#fff', border: 'none' }}>
      <FlexColumn css={styles.container}>
        <div css={styles.header}>
          <div css={styles.flex}>
            <Icon icon={'MONEY'} />
            <Text
              type="caption"
              color="primaryHeading"
              outset={{ top: 'x_25' }}
              inset={{ left: 'x1' }}
              weight="bold"
            >
              Credits
            </Text>
          </div>
        </div>
        <div css={{ ...styles.flex, ...styles.contents }}>
          <FlexColumn css={styles.flexColumn}>
            <SuspenseBoundary
              unresolved={<CircularProgress />}
              failure={() => <CreditsUnavailable />}
            >
              <ReferralCredits />
            </SuspenseBoundary>
          </FlexColumn>
        </div>
      </FlexColumn>
    </BaseCreditCard>
  )
}

export default ReferralCreditsCard
